import { useState } from "react";

import { VisualState, useKBar } from "kbar";

// The palette hands focus back to the control that opened it, which would open that control's tooltip over the next page; it waits for a new hover or focus.
export const usePaletteTriggerTooltip = () => {
  const { isOpen } = useKBar((state) => ({
    isOpen: state.visualState !== VisualState.hidden,
  }));
  const [isHeld, setIsHeld] = useState(false);
  const release = () => {
    if (!isOpen) {
      setIsHeld(false);
    }
  };
  return {
    isTooltipDisabled: isOpen || isHeld,
    holdTooltip: () => setIsHeld(true),
    triggerProps: { onPointerEnter: release, onBlur: release },
  };
};
